import styled from 'styled-components';

const Link = styled.a`
  text-decoration: underline;
  color: ${props => props.theme.colors.black};
`;

export default Link;
